import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-reference',
  templateUrl: './reference.component.html',
  styleUrls: ['./reference.component.css']
})
export class ReferenceComponent implements OnInit {

  constructor(private modalService: NgbModal) { }

  ngOnInit(): void {
  }

  open(disclaimer:any, url: any) {
    this.modalService.open(disclaimer, { size: 'md', ariaLabelledBy: 'modal-basic-title' }).result.then((result: any) => {
      
    }, (reason: any) => {
        if (reason == "ok")
          window.open(url, "_blank");
    });
  }
}
